export default "__VITE_ASSET__DnDCycGx__"